/* eslint-disable no-use-before-define */
import React, { FC } from 'react';
import { Sparkles, Paperclip, ArrowUp } from 'lucide-react';
import { useTranslate } from 'hooks/useTranslate';

type AiAgentInputProps = {
  input: string;
  onKeyDown: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void; // eslint-disable-line no-unused-vars
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void; // eslint-disable-line no-unused-vars
  onSubmit: () => void;
  isProcessing: boolean;
  hasStartedChat: boolean;
};

const AiAgentInput: FC<AiAgentInputProps> = ({
  input,
  onKeyDown,
  onChange,
  onSubmit,
  isProcessing,
  hasStartedChat,
}) => {
  const { t } = useTranslate();

  return (
    <div
      className={`input-section ${
        hasStartedChat ? 'input-section-sticky' : ''
      }`}
    >
      <div className="textarea-container">
        <textarea
          value={input}
          onChange={onChange}
          onKeyDown={onKeyDown}
          placeholder={t(
            hasStartedChat
              ? 'AI_InputAnotherPlaceholder'
              : 'AI_InputPlaceholder'
          )}
        />
      </div>

      <div className="input-footer">
        <div className="footer-left">
          {/* <button type="button" className="btn btn-ghost btn-sm">
                New Project
              </button> */}
          <button type="button" className="btn btn-ghost btn-sm">
            v0.0.1-stk
          </button>
        </div>

        <div className="footer-right">
          <button type="button" className="btn btn-ghost btn-sm">
            <Sparkles />
          </button>
          <button type="button" className="btn btn-ghost btn-sm">
            <Paperclip />
          </button>
          <button
            type="button"
            onClick={onSubmit}
            disabled={!input.trim() || isProcessing}
            className="btn btn-primary btn-sm"
          >
            {isProcessing ? (
              <div className="spinner spinner-white" />
            ) : (
              <ArrowUp />
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AiAgentInput;
